export default {
  name: 'tj',
  namespaced: true,
  state() {
    return {}
  },
  getters: {},
  mutations: {},
  actions: {}
}
